import { Stack, TabPanel, TabPanelProps } from '@chakra-ui/react';
import {
  useFetchTermsAndConditionsQuery,
} from 'api';
import { useAuth } from 'core';

export interface ClientTermsAndConditionsTabPanelProps extends TabPanelProps {}

export const ClientTermsAndConditionsTabPanel = (
  props: ClientTermsAndConditionsTabPanelProps
) => {
  const { ...other } = props;
  const auth = useAuth();
  const { data: termsAndConditions, isLoading } =
    useFetchTermsAndConditionsQuery({
      clientId: auth?.user?.clientId ?? "0",
    });

  let body = <>Loading...</>;

  if (!isLoading) {
    body = <>{termsAndConditions?.content}</>;
  }

  return (
    <TabPanel {...other}>
      <Stack>{body}</Stack>
    </TabPanel>
  );
};
